import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class SupplierService extends GenericService {
    constructor() {
        super('/suppliers', axiosInstance);
    }

    async pushCloud(supplierId, payload = {}) {
        try {
            const response = await axiosInstance.post(
                `${this.baseUrl}/${this.encodePathSegment(supplierId)}/cloud/push`,
                payload
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new SupplierService(); 